import {ProfileInjury} from '../resources/ProfileInjury';
import {DomainEvent} from './DomainEvent';

export class ProfileSeasonInjuryUpdated extends DomainEvent<ProfileInjury> {}
